import { Component, EventEmitter, Input, Output, OnInit, AfterViewInit } from '@angular/core';

import { isEmptyString } from '@helpers';
import { UIKolom } from './kolom.model';

@Component({
  selector: 'ecert-kolommen-instellen',
  templateUrl: './ecertnl-kolommen-instellen.component.html',
  styleUrls: ['./ecertnl-kolommen-instellen.component.css'],
  standalone: false,
})
export class EcertKolommenInstellenComponent implements OnInit, AfterViewInit {
  @Input() tabelnaam: string;
  @Input() dragulaId: string;
  @Input() toonKolomKeuze = false;

  /**
   * Tekst bij de + knop voor het openklappen van de kolom-selecties
   */
  @Input() actionIdInstellen: string;
  /**
   * Uitleg bovenin bij opengeklapte kolom-selecties
   */
  @Input() actionIdInstellenUitleg: string;

  /**
   * Tekst voor de reset-knop. Reset: naar fabrieks-instellingen
   * Indien niet gedefinieerd (null, undefined, '') valt de knop weg
   */
  @Input() actionIdInstellenReset = '';
  /**
   * Tekst voor de annuleer-knop. Annuleer: naar vorige opgeslagen instellingen
   * Indien niet gedefinieerd (null, undefined, '') valt de knop weg
   */
  @Input() actionIdInstellenAnnuleer = '';
  /**
   * Tekst voor de bewaar-knop. Bewaar: in local-storage
   * Indien niet gedefinieerd (null, undefined, '') valt de knop weg.
   *     Maar: waar doe je het dan voor?
   */
  @Input() actionIdInstellenBewaar = '';

  /**
   * Uitleg bovenaan de kolom actieve selecties
   */
  @Input() actionIdInstellenAan: string;
  /**
   * Uitleg bovenaan de kolom niet-actieve selecties
   */
  @Input() actionIdInstellenUit: string;

  private _gewijzigd = false;

  private _actieveKolommen: UIKolom[] = [];
  private _actieveKolommenSleepbaar: UIKolom[] = [];
  private _actieveKolommenSleepbaarJson = '';
  @Output() actieveKolommenChange = new EventEmitter<UIKolom[]>();

  @Input()
  set actieveKolommen(actieveKolommen: UIKolom[]) {
    this._actieveKolommen = actieveKolommen;
    this.actieveKolommenSleepbaar = actieveKolommen;
  }
  set actieveKolommenSleepbaar(actieveKolommen: UIKolom[]) {
    if (JSON.stringify(actieveKolommen) !== this._actieveKolommenSleepbaarJson) {
      this._gewijzigd = true;
      this._actieveKolommenSleepbaar = actieveKolommen;
      this._actieveKolommenSleepbaarJson = JSON.stringify(actieveKolommen);
      this.actieveKolommenChange.emit(actieveKolommen);
    }
  }
  get actieveKolommenSleepbaar(): UIKolom[] {
    return this._actieveKolommenSleepbaar;
  }

  private _inactieveKolommen: UIKolom[] = [];
  private _inactieveKolommenSleepbaar: UIKolom[] = [];
  private _inactieveKolommenSleepbaarJson = '';
  @Output() inactieveKolommenChange = new EventEmitter<UIKolom[]>();

  @Input()
  set inactieveKolommen(inactieveKolommen: UIKolom[]) {
    this._inactieveKolommen = inactieveKolommen;
    this.inactieveKolommenSleepbaar = inactieveKolommen;
  }
  set inactieveKolommenSleepbaar(inactieveKolommen: UIKolom[]) {
    if (JSON.stringify(inactieveKolommen) !== this._inactieveKolommenSleepbaarJson) {
      this._gewijzigd = true;
      this._inactieveKolommenSleepbaar = inactieveKolommen;
      this._inactieveKolommenSleepbaarJson = JSON.stringify(inactieveKolommen);
      this.inactieveKolommenChange.emit(inactieveKolommen);
    }
  }
  get inactieveKolommenSleepbaar(): UIKolom[] {
    return this._inactieveKolommenSleepbaar;
  }

  @Output() verversKolommen = new EventEmitter<void>();
  @Output() bewaarKolomIndeling = new EventEmitter<void>();
  @Output() annuleerKolomIndeling = new EventEmitter<void>();
  @Output() resetKolomIndeling = new EventEmitter<void>();

  get heeftResetKnop(): boolean {
    return !isEmptyString(this.actionIdInstellenReset);
  }

  get heeftAnnuleerKnop(): boolean {
    return !isEmptyString(this.actionIdInstellenAnnuleer);
  }

  get heeftResetEnAnnuleerKnop(): boolean {
    return !isEmptyString(this.actionIdInstellenReset) && !isEmptyString(this.actionIdInstellenAnnuleer);
  }

  get heeftGeenResetOfAnnuleerKnop(): boolean {
    return isEmptyString(this.actionIdInstellenReset) && isEmptyString(this.actionIdInstellenAnnuleer);
  }

  get heeftBewaarKnop(): boolean {
    return !isEmptyString(this.actionIdInstellenBewaar);
  }

  get gewijzigd(): boolean {
    return this._gewijzigd;
  }

  public ngOnInit(): void {
    if (isEmptyString(this.tabelnaam)) {
      console.error('Geen tabelnaam gedefinieerd');
    }
    if (isEmptyString(this.dragulaId)) {
      console.error('Geen dragula-id gedefinieerd voor', this.tabelnaam);
    }
  }

  public ngAfterViewInit(): void {
    this._gewijzigd = false;
  }

  ververs() {
    this.verversKolommen.emit();
    this._gewijzigd = true;
  }

  bewaar() {
    this.bewaarKolomIndeling.emit();
    this._gewijzigd = false;
    this.toonKolomKeuze = false;
  }

  annuleer() {
    this.annuleerKolomIndeling.emit();
    this._gewijzigd = false;
    this.toonKolomKeuze = false;
  }

  reset() {
    this.resetKolomIndeling.emit();
    this._gewijzigd = false;
    this.toonKolomKeuze = false;
  }
}
